import { RawRuleOf } from '@casl/ability';

import { AppAbility } from '../../../shared/modules/authz/types/app-ability';
import { UserRoleEnum } from '../../../shared/modules/users/enums/user-role.enum';

/**
 * Session principal for a platform operator.
 *
 * Stands alone rather than extending BaseDto so tenant audit and display
 * fields cannot be read off an ops principal by accident. Unannotated: this
 * DTO is an auth principal, not a CASL resource.
 */
export class PlatformUserRecordDto {
  id!: number;
  username!: string;
  authProviderName!: string;
  authProviderUserId!: string;
  email!: string;
  userRoleName!: UserRoleEnum;
  userRolePermissions!: RawRuleOf<AppAbility>[];
}
